import { render, staticRenderFns } from "./LowBatteryAlertSettingEditor.vue?vue&type=template&id=2a546af4&scoped=true&lang=pug"
import script from "./LowBatteryAlertSettingEditor.vue?vue&type=script&lang=ts"
export * from "./LowBatteryAlertSettingEditor.vue?vue&type=script&lang=ts"
import style0 from "./LowBatteryAlertSettingEditor.vue?vue&type=style&index=0&id=2a546af4&prod&lang=scss&scoped=true"
import style1 from "./LowBatteryAlertSettingEditor.vue?vue&type=style&index=1&id=2a546af4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a546af4",
  null
  
)

export default component.exports